/* eslint-disable no-unused-vars */
import { useRef, useEffect, useMemo, useCallback } from 'react';
import { DeleteFromUpload } from 'assets/icons';
import { useSelector, useDispatch } from 'react-redux';
import { creativesActions } from 'store/campaign/creatives';
import { ModalHeader, ModalFooter, Loader, Search, Separators, Each } from 'components';
import * as S from './Repository.styled';
import { useSignal, useComputed } from '@preact/signals-react';
import { manageCreativeMediaAPI } from 'services/manageCreativeMedia.service';
import { ListItem } from './ListItem';
import { SearchAndDelete } from './SearchAndDelete';
import { ImgPreview } from './ImgPreview';
import { ImgUploader } from './imgUploader/ImgUploader';

export const Repository = ({
  isOpen$,
  isLoading,
  imgList,
  previewSectionImage$,
  detectWidthAndHeight,
  currentSelectedSize$,
  uploadAction,
  uploadResult,
  isFetching,
}) => {
  const app_package = useSelector((state) => state.creatives.creativeAndTrackingData.app_package);
  const banners = useSelector((state) => state?.creatives?.selectedCreative?.banners);

  const selectedImg$ = useSignal(false);
  const dataToImgFetch = useMemo(
    () => ({
      package_id: app_package,
      image_type: currentSelectedSize$.value.imageType,
      media_id: selectedImg$.value?.media_id,
    }),
    [app_package, currentSelectedSize$.value?.imageType, selectedImg$.value?.media_id],
  );

  const [deleteImgAction, deleteImgResult] =
    manageCreativeMediaAPI.useRemoveCreativeImageMutation();

  const searchValue$ = useSignal('');

  const searchRef = useRef(null);
  const dispatch = useDispatch();

  const filteredItems = useMemo(() => {
    if (!searchValue$.value) return imgList;
    return imgList.filter(({ file_name }) =>
      file_name.toLowerCase().includes(searchValue$.value.toLowerCase()),
    );
  }, [imgList, searchValue$.value]);

  const onDelete = async () => {
    let res;
    res = await deleteImgAction(dataToImgFetch);
    if (res?.data?.success) {
      selectedImg$.value = false;
      return;
    }
    if (res?.error?.data) {
      alert(res.error.data.Message);
      return;
    }
  };

  const saveButtonOnClick = () => {
    const isContain = banners.findIndex(
      (banner) => banner.media_id === selectedImg$.value.media_id,
    );
    if (isContain === -1) {
      const objToSave = {
        file_name: selectedImg$.value.file_name,
        image_size: selectedImg$.value.image_size,
        image_type: selectedImg$.value.image_type,
        media_id: selectedImg$.value.media_id,
        // package_id: '',
        // pb_id: '',
        // pba_id: '',
      };
      dispatch(
        creativesActions.updateProperty({
          propField: 'banners',
          newValue: [...banners, objToSave],
        }),
      );
      isOpen$.value = false;
      previewSectionImage$.value = selectedImg$.value;
      currentSelectedSize$.value = '';
    } else {
      alert('This creative has already been selected.');
    }
  };

  return (
    <>
      <ModalHeader
        title='Creatives manager'
        close={() => {
          isOpen$.value = false;
        }}
      />
      <SearchAndDelete
        searchRef={searchRef}
        searchValue$={searchValue$}
        onDelete={onDelete}
        selectedImg$={selectedImg$}
      />
      <Separators type={Separators.separatorTypes.small} />
      <div style={{ display: 'flex' }}>
        <div style={{ flexGrow: '1' }}>
          <ImgUploader
            resolutionWidth={detectWidthAndHeight(currentSelectedSize$.value.imageType).width}
            resolutionHeight={detectWidthAndHeight(currentSelectedSize$.value.imageType).height}
            selectedImg$={selectedImg$}
            currentSelectedSize$={currentSelectedSize$}
            uploadAction={uploadAction}
            uploadResult={uploadResult}
          />

          <Separators type={Separators.separatorTypes.small} />
          {(isLoading || isFetching) && (
            <div style={{ height: 400, display: 'grid', placeItems: 'center' }}>
              <Loader.Local delay={0} />
            </div>
          )}
          {!isLoading && !isFetching && !filteredItems?.length && (
            <S.EmptyPage>Upload Creative, please.</S.EmptyPage>
          )}
          {filteredItems?.length > 0 && !isFetching ? (
            <S.ItemsContainer>
              <Each
                fieldOfIndex='media_id'
                of={filteredItems}
                render={(item, index) => {
                  return (
                    <ListItem selectedImg$={selectedImg$} item={item} searchValue$={searchValue$} />
                  );
                }}
              />
            </S.ItemsContainer>
          ) : null}
        </div>
        {useComputed(() => (
          <ImgPreview selectedImg={selectedImg$.value} />
        ))}
      </div>
      <Separators type={Separators.separatorTypes.small} />
      {useComputed(() => (
        <ModalFooter
          saveButtonText='Use this Creative'
          saveButtonOnClick={saveButtonOnClick}
          close={() => {
            isOpen$.value = false;
          }}
          saveButtonDisabled={!selectedImg$.value}
        />
      ))}
    </>
  );
};
